<template>
    <div class="lineageChart">
        <Head :index="'1'"></Head>

        <!-- <div class="chartTop">
            <h1 class="fl">
                个人信息
            </h1>
            <div style="width: calc(100% - 350px);">
                {{ familyData.befrom }}{{ familyData.familyname }}|{{ familyData.ancestorname }}
                <span> {{ familyData.tangnum }} 共 {{ familyData.num }}人</span>
            </div>
        </div> -->
        <div style="height: 100%;" v-show="showType">
            <div class="fl info">
                <div class="avator" @click="clickfile">
                    <img v-if="avatorIma!=''" :src="'https://www.xsdjp.com' + avatorIma  || ''" alt=""/>
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </div>

                <input type="file" name="" ref="file" accept="image/jpeg,image/jpg,image/png" @change="changeImage" style="display:none" />
                <div class="fr" style="position:relative;height:120px">
                    <h2>{{ info.xm }}</h2>
                    <p><span>[{{ info.sdlr }} - {{ info.qssdlr }}]</span>&nbsp;
                        <span>[{{ info.shixu }}世] </span> </p>
                    <!-- <p>{{ toChies(info.shixu) }}世 <span v-if="info.sgzt == 0">在世</span><span v-else>已故</span></p>
                    <p>
                        {{ info.sr || "未知" }} - <span v-if="info.sgzt == 0">至今</span><span v-else>{{ info.qssj }}</span>
                    </p>-->
                    <div class="btnDiv" style="position:absolute;bottom:-10px;left:55px;">
                        <el-button type="text" @click="edit(data.id)">编辑</el-button>
                        <el-button type="text" @click="add()">添加</el-button>
                        <el-button type="text" @click="moreClick">更多</el-button>
                    </div>
                </div>
                <!-- <div class="btnDiv">
                    <el-button type="text" @click="edit(data.id)">编辑</el-button>
                    <el-button type="text" @click="add()">添加</el-button>
                    <el-button type="text">更多</el-button>
                </div> -->
                <!-- <div class="spjj">
                    <h3>生平简介</h3>
                    <p>
                        {{ info.spjj || "暂无简介" }}
                    </p>
                </div> -->
            </div>
            <div class="fr chart" ref="chart">
                <el-tabs v-model="activeName" @tab-click="tabClick">
                    <!-- @tab-click="handleClick" -->
                    <el-tab-pane label="树状结构世系图" name="first">
                        <el-input placeholder="输入关键字进行查找（或搜索）" v-model="filterText" suffix-icon="el-icon-search"> </el-input>
                        <div>
                            <el-tree
                                class="filter-tree"
                                node-key="id"
                                :data="data"
                                :props="defaultProps"
                                :expand-on-click-node="false"
                                default-expand-all
                                :filter-node-method="filterNode"
                                ref="tree"
                            >
                                <span class="custom-tree-node" slot-scope="{ node, data }" @click="NodeClick(data)">
                                    <i class="el-icon-s-custom" :style="{ color: data.sex == 0 ? '' : '#ffabd5' }"></i>
                                    <span :style="{ 'font-size': '14px', color: data.sex == 1 ? '#ffabd5' : '' }" v-html="data.xm"> </span>
                                    <span v-if="data.ph != 0">[{{ data.sex == 0 ? "" : "女" }}行{{ data.ph == 0 ? "一" : toChies(data.ph) }} ]</span>
                                    <span>
                                        [{{ data.dc }} - {{ data.jc }}]
                                        <!-- [{{ data.dc != "" && data.dc != null ? data.dc : "未知" }} - {{ data.jc != "" && data.jc != null ? data.jc : "至今" }}] -->
                                    </span>
                                    <span> [{{ data.shixu }}世]</span>
                                    <span @click.stop="delMember(data)">删除</span>
                                </span>
                            </el-tree>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="组织结构世系图" name="second" ref="paneChart" id="paneChart">
                        <div id="image-container"  v-viewer>
                            <!-- <button type="button" class="button" @click="imgShow">URL Array</button> -->
                            <img style="width:100%;display:none" :src="chartsSrc"  @click="imgShow" >
                       
                            <!-- 手势提示图 -->
                        <!-- <div v-if="showHint" class="hint-overlay" >
                            <div class="hint-content">
                                <img src="../../assets/img/img_b.jpg" alt="双指缩放手势" />
                                <p>双指开合以缩放图片</p>
                            </div>
                        </div> -->
                        <!-- 放大手势提示 -->
                        <div v-if="showZoomInHint" class="gesture-hint" style="z-index:9999">
                            <img :src="zoomInImage" alt="放大手势" class="gesture-img"/>
                            <p>双指张开放大</p>
                        </div>

                        <!-- 缩小手势提示 -->
                        <div v-if="showZoomOutHint" class="gesture-hint" style="z-index:9999">
                            <img :src="zoomOutImage" alt="缩小手势" class="gesture-img"/>
                            <p>双指合拢缩小</p>
                        </div>
                    </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>

        <div class="pcinfoDiv" v-if="!showType">
            <div>
                <ul class="fl" ref="infoUrl">
                    <li>
                        <a href="javascript:;" @click="liType('info')" :class="{ active: type == 'info' }">个人基本信息</a>
                    </li>
                    <li v-if="$store.state.sgztData">
                        <a href="javascript:;" @click="liType('funeral')" :class="{ active: type == 'funeral' }">去世安葬信息</a>
                    </li>
                    <li v-if="$store.state.hyztData">
                        <a href="javascript:;" @click="liType('spouse')" :class="{ active: type == 'spouse' }">配偶生育信息</a>
                    </li>
                    <li v-if="!$store.state.sgztData">
                        <a href="javascript:;" @click="liType('personal')" :class="{ active: type == 'personal' }">联系信息</a>
                    </li>
                    <li>
                        <a href="javascript:;" @click="liType('zlhz')" :class="{ active: type == 'zlhz' }">汇总信息</a>
                    </li>
                    <li>
                        <!-- <router-link to="/lineageChart">返回世系图</router-link> -->
                        <a href="javascript:;" @click="showType = true">返回世系图</a>
                    </li>
                </ul>
                <div class="fl">
                    <Child :pType="type" @liType="liType" @submitFun="submitFun" @showFun="showFun"></Child>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="dialogVisible" width="150px" class="operateApp" :show-close="false">
            <span>
                <div class="name">
                    <span class="xm"></span>
                    <span class="spousse"></span>
                    <p style="top:0">
                        {{ memberXm }}
                    </p>
                    <div
                        class=""
                        :class="{
                            selector: true,
                            two: znShow,
                            tree: !znShow
                        }"
                    >
                        <div class="selector open">
                            <ul>
                                <li v-if="memberData.fatherid == 0" style="transform: rotate(0deg);">
                                    <el-button type="primary" @click="addFun(1, 0)">添加父亲</el-button>
                                </li>
                                <li v-if="memberData.fatherid == 0">
                                    <el-button type="primary" @click="getInfo(memberData.id)">查看简介</el-button>
                                </li>
                                <!-- <li v-if="memberData.fatherid != 0">
                                    <el-button type="primary" @click="addFun(1)">添加母亲</el-button>
                                </li> -->
                                <li>
                                    <el-button type="success" @click="edit()" class="edit">编辑</el-button>
                                </li>
                                <li v-if="memberData.fatherid != 0">
                                    <el-button type="primary" @click="addFun(3, 0)" class="brother">添加兄弟</el-button>
                                </li>
                                <li v-if="memberData.fatherid != 0">
                                    <el-button type="primary" @click="addFun(3, 1)" class="sisters">添加姐妹</el-button>
                                </li>
                                <li v-if="znShow">
                                    <el-button type="primary" @click="addFun(2, 0)" class="son">添加儿子</el-button>
                                </li>
                                <li v-if="znShow">
                                    <el-button type="primary" @click="addFun(2, 1)" class="daughter">添加女儿</el-button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </span>
            <template #footer>
                <span class="dialog-footer"> </span>
            </template>
        </el-dialog>

        <el-dialog :visible.sync="dialogFamily" width="600px">
            <span> </span>
        </el-dialog>

        <el-dialog :visible.sync="dialogMap" width="90%" class="map">
            <!-- <vmap @getLnglat="getPosi" :formKey="formKey"></vmap> -->
        </el-dialog>

        <el-dialog :visible.sync="dialogInfo" width="90%" class="map">
            <!-- <vmap @getLnglat="getPosi" :formKey="formKey"></vmap> -->
            <div>
                {{infoData.name}}&nbsp;&nbsp;
                <div v-html="infoData.info"></div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="uploadAvator" width="60%" @close="closeFun">
            <div style="width:100%;height:400px">
                <vue-cropper autoCrop :img="imageUrl" ref="cropper" centerBox />
            </div>
            <el-button type="primary" @click="getCropData()" block style="margin:10px 0">上传</el-button>
        </el-dialog>
    </div>
</template>
<script>
import Head from "@/components/header.vue";
import Child from "./info/child.vue";
// import orgtree from "@/components/orgtree.vue";

import api from "@/request/api";
// // import vmap from "@/components/vmap.vue";
// import Area from "@/components/area.vue";

import "viewerjs/dist/viewer.css";
import {api as viewerApi} from "v-viewer";

export default {
    data() {
        return {
            paneImg:'',
            showType: true,
            dialogVisible: false,
            dialogFamily: false,
            dialogMap: false,
            uploadAvator: false,
            formKey: "",
            data: [],
            memberData: {},
            memberXm: "",
            familyData: {},
            info: {},
            avatorIma:'',
            imageUrl: "",
            znShow: true,
            szmz: "",
            activeName: "first",
            echartsInit: null,
            form: {
                mz: "",
                xm: "",
                shixu: "",
                pname: "",
                relation: "",
                sex: 0
            },
            dialogInfo: false,
            infoData: "",
            chartsSrc: "",
            chartsSrcs: [],
            filterText: "",
            defaultProps: {
                children: "children",
                label: "xm"
            },
            type: "info",
            mtype: "",
            hintTimeout: null, // 定时器句柄
            showHint:false,
            showZoomInHint: false,   // 控制放大手势提示的显示
            showZoomOutHint: false,  // 控制缩小手势提示的显示
            ratioValue:0.3,//缩放尺寸
            zoomInImage: require('@/assets/img/img_b.jpg'), // 本地图片路径
            zoomOutImage: require('@/assets/img/img_s.jpg'), // 本地图片路径
     
        };
    },
    mounted() {
        this.getList();
        this.getmyinfo(localStorage.getItem("fid"), "sz");
        api.familyGet(localStorage.getItem("fid")).then((res) => {
            this.familyData = res.data;
        });
        // const imageContainer = document.getElementById("image-container");
        //     // 监听缩放和拖动事件，隐藏手势提示
        // imageContainer.addEventListener("wheel", this.hideGestureHint);
        // imageContainer.addEventListener("mousedown", this.hideGestureHint);
        // imageContainer.addEventListener("touchstart", this.hideGestureHint);
    },
    methods: {
        // 显示手势提示
        showGestureHint() {
        const hint = document.getElementById("gesture-hint");
        hint.style.display = "block";

        // 自动隐藏提示
        this.hintTimeout = setTimeout(() => {
            this.hideGestureHint();
        }, 3000); // 3秒后隐藏
        },// 隐藏手势提示
        hideGestureHint() {
            const hint = document.getElementById("gesture-hint");
            if (hint) {
                hint.style.display = "none";
            }

            // 清除定时器
            if (this.hintTimeout) {
                clearTimeout(this.hintTimeout);
                this.hintTimeout = null;
            }
        },
        // 监听 Viewer.js 的 zoom 事件
        onZoom(event) {// 获取当前缩放比例
            const zoomRatio = event.detail.ratio.toFixed(2);
            console.log(zoomRatio,'--------------zoomRatio')
            console.log(this.ratioValue,'--------------ratioValue')
            if (zoomRatio > this.ratioValue) {
                // 如果是放大操作
                this.showZoomInHint = true;
                this.showZoomOutHint = false;

                // this.$message({
                // dangerouslyUseHTMLString: true,
                // message: '<div><p>双指开合放大</p><img src="../../assets/img/img_b.jpg" alt="放大手势" class="gesture-img"/></div>'
                // });
            } else if (zoomRatio < this.ratioValue) {
                // // 如果是缩小操作
                this.showZoomInHint = false;
                this.showZoomOutHint = true;
            }
            this.ratioValue=zoomRatio
      
        // 设置定时器，2秒后隐藏提示
            setTimeout(() => {
                this.showZoomInHint = false;
                this.showZoomOutHint = false;
            }, 2000);
        },
        tabClick(){
          if(this.activeName=='second'){
            if (this.chartsSrc == "") {
                const loading = this.$loading({
                    lock: true,
                    // text: "组织结构世系图生成中，请稍后……",
                    text: "超大图，加载需要时间，请耐心等待",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
                
                api.familyGetchat(localStorage.getItem("fid")).then((res) => {
                    this.chartsSrc = "https://www.xsdjp.com" + res.data;
                    this.chartsSrcs[0]= "https://www.xsdjp.com" + res.data;
                    loading.close()
                    this.imgShow()
                });

            }else{
                this.imgShow()
            }
          }
        },
        imgShow(){
            var that=this;
            const loading = this.$loading({
                lock: true,
                // text: "组织结构世系图生成中，请稍后……",
                text: "超大图，加载需要时间，请耐心等待",
                spinner: "el-icon-loading",
                color:"rgba(255,255,255,1)",
                background: "rgba(0, 0, 0, 0.5)",
            });
            const $viewer = this.$viewerApi({
                images: this.chartsSrcs,
                options: {
                    index: 0,        // 初始显示图像的索引
                    title: true,    // 是否显示图像标题
                    toolbar: true,   // 是否显示工具栏
                    navbar: false,    // 是否显示导航栏
                    tooltip: true,   // 是否显示缩放和旋转工具提示
                    movable: true,   // 是否允许拖动
                    zoomable: true,  // 是否允许缩放
                    rotatable: true, // 是否允许旋转
                    scalable: true,  // 是否允许变焦
                    viewed() {
                        loading.close();
                        // 使用 $viewer 实例
                        $viewer.zoomTo(0.3); // 图片加载后，设置缩放比例为 30%
                        $viewer.rotateTo(90); // 图片加载后，默认旋转 90 度
                    } ,
                    zoom(event){
                        that.onZoom(event);
                    }
                    // ready(){
                    //     // 打开图片时显示手势提示
                    //     this.showGestureHint();
                    // }
                },
               
            });
        },
        handleLabelReg(label, searchStr) {
            const reg = new RegExp(searchStr, "gi");
            let start = 0;
            let end = 0;
            let newStr = "";
            let arr;
            while ((arr = reg.exec(label)) !== null) {
                end = arr.index;
                newStr = newStr + label.slice(start, end);
                start = end;
                end = reg.lastIndex;
                newStr = newStr + `<span style="color: red">${label.slice(start, end)}</span>`;
                start = end;
            }
            newStr = newStr + label.slice(end);
            return newStr;
        },
        filterNode(value, data) {
            data.xm = data.xm.replace(/<[^>]*>|/g, "");
            if (!value) return true;
            if (data.xm.indexOf(value) !== -1) {
                data.xm = this.handleLabelReg(data.xm, value);
            }
            return data.xm.indexOf(value) !== -1;
        },
        submitFun(data) {
            this.showType = true;
            if (this.mtype == "Add") {
                this.familyData.num = this.familyData.num + 1;
                if (this.form.relation == 1) {
                    data.children = [this.data];
                    this.data = data;
                } else if (this.form.relation == 2) {
                    this.childrenNode(this.data, data);
                } else if (this.form.relation == 3) {
                    this.addBrotherNode(this.data, data);
                }
            } else {
                this.editNode(this.data, data);
                this.$forceUpdate();
            }
        },
        showFun(data) {
            this.showType = data;
        },
        editNode(treeData, data) {
            for (let i = 0; i < treeData.length; i++) {
                if (treeData[i].id === Number(data.id)) {
                    treeData[i] = data;
                    break;
                }
                if (treeData[i].children && treeData[i].children.length > 0) {
                    this.editNode(treeData[i].children, data);
                }
            }
            return treeData;
        },

        childrenNode(treeData, data) {
            for (let i = 0; i < treeData.length; i++) {
                if (treeData[i].id === Number(data.onceid)) {
                    treeData[i].children.push(data);
                    break;
                }
                if (treeData[i].children && treeData[i].children.length > 0) {
                    this.childrenNode(treeData[i].children, data);
                }
            }
            return treeData;
        },
        addBrotherNode(treeData, data) {
            for (let i = 0; i < treeData.length; i++) {
                if (treeData[i].id === Number(data.onceid)) {
                    treeData.push(data);
                    break;
                }
                if (treeData[i].children && treeData[i].children.length > 0) {
                    this.addBrotherNode(treeData[i].children, data);
                }
            }
            return treeData;
        },
        getInfo(id) {
            api.getInfo(this.$qs.stringify({ fid: localStorage.getItem("fid"), mid: id, num: 1 })).then((res) => {
                this.infoData = res.data[0];
                this.dialogInfo = true;
            });
        },
        append(data) {
            this.getmyinfo(data.id);
        },
        getmyinfo(val, type) {
            api.memberGet(val).then((res) => {
                if (res.code == 0) {
                    this.info = res.data;
                    // console.log(this.info,'---info')
                    if(this.info.avator&&this.info.avator.length!=0){
                        this.avatorIma=this.info.avator[0].url
                    }else{
                        this.avatorIma=''
                    }
                    this.form.mz = res.data.mz;
                    this.$store.dispatch("getActionsData", { key: "mid", val: res.data.id });
                    if (type == "sz") {
                        this.szmz = res.data.mz;
                    }
                }
            });
        },
        getCropData() {
            this.$refs.cropper.getCropData((data) => {
                api.uploadAvator(
                    this.$qs.stringify({
                        fid: localStorage.getItem("fid"),
                        mid: this.info.id,
                        img: data
                    })
                ).then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            message: "上传成功",
                            type: "success"
                        });
                        this.uploadAvator = false;
                        this.avatorIma=res.data.url
                        // this.getmyinfo();
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "warning"
                        });
                    }
                });
            });
        },
        clickfile() {
            this.$refs.file.click();
        },
        changeImage(e) {
            var file = e.target.files[0];
            var reader = new FileReader();
            var that = this;
            reader.readAsDataURL(file);
            reader.onload = function(e) {
                that.imageUrl = this.result;
                that.uploadAvator = true;
            };
        },
        closeFun() {
            this.$refs.file.value = "";
        },
        tabShowFun(val) {
            if (val == 0) {
                this.tabShow = false;
            } else {
                this.tabShow = true;
            }
        },
        getList() {
            api.memberListtree(localStorage.getItem("fid"),0).then((res) => {
                if (res.code == 0) {
                    this.data = res.data;
                    this.form.xm = res.data[0].xm.split("")[0];
                    this.form.mz = res.data[0].mz;
                    sessionStorage.setItem("memberId", res.data[0].id);
                    this.getmyinfo(res.data[0].id);
                    // this.echartsFun();
                }
            });
        },
        moreClick(){
            console.log(this.data,'----moreClickdata')
            console.log(this.data[0],'----moreClick[0]')
            this.NodeClick(this.data[0])
        },
        NodeClick(data) {
            this.getmyinfo(data.id);
            this.memberXm = data.xm.replace(/<[^>]*>|/g, "");
            this.memberData = data;
            sessionStorage.setItem("memberId", data.id);
            this.form.shixu = data.shixu;
            var pxm = this.parentName([this.data], data.id);
            this.$store.dispatch("getActionsData", { key: "pxm", val: pxm[pxm.length - 2] });
            this.dialogVisible = true;
            this.znShow = data.sex == 0 ? true : false;
        },
        parentName(arr1, id) {
            var temp = [];
            var forFn = function(arr, id) {
                for (var i = 0; i < arr.length; i++) {
                    var item = arr[i];
                    if (item.id === id) {
                        forFn(arr1, item.fatherid);
                        temp.push(item.xm);
                        break;
                    } else {
                        if (item.children) {
                            forFn(item.children, id);
                        }
                    }
                }
            };

            forFn(arr1, id);
            return temp;
        },
        parentId(arr1, id) {
            var temp = [];
            var forFn = function(arr, id) {
                for (var i = 0; i < arr.length; i++) {
                    var item = arr[i];
                    if (item.id === id) {
                        forFn(arr1, item.fatherid);
                        temp.push(item.id);
                        break;
                    } else {
                        if (item.children) {
                            forFn(item.children, id);
                        }
                    }
                }
            };
            forFn(arr1, id);
            return temp;
        },

        spouseOpen() {
            this.$router.push("/spouse");
        },
        addFun(val, sex) {
            this.form.relation = val;
            this.form.sex = sex;
            sessionStorage.setItem("memberType", "Add");
            this.mtype = "Add";
            if (val == 3) {
                this.form.pname = this.info.fqxm;
            } else {
                this.form.pname = this.info.xm;
            }
            sessionStorage.setItem("form", this.$qs.stringify(this.form));
            this.$router.push("/mobileinfo");
            // this.showType = false;
            // this.dialogVisible = false;
            // this.liType("info");
        },
        add() {
            this.memberData = this.info;
            this.dialogVisible = true;
            this.getmyinfo(0);
            this.znShow = this.info.sex == 0 ? true : false;
            this.form.shixu = this.info.ph;
            // this.liType("info");
        },
        edit() {
            this.$store.dispatch("getActionsData", { key: "relation", val: "" });
            sessionStorage.setItem("memberType", "Edit");
            this.$router.push("/mobileinfo");
            // this.mtype = "Edit";
            // this.showType = false;
            // this.dialogVisible = false;
            // this.liType("info");
        },
        delMember(data) {
            this.$alert("确定删除" + data.xm, "删除人员", {
                confirmButtonText: "确定",
                customClass: 'msgAlertBox',  
                callback: (action) => {
                    if (action == "confirm") {
                        api.memberDel(data.id).then((res) => {
                            if (res.code == 0) {
                                this.familyData.num = this.familyData.num - 1;
                                this.delNode(this.data, data);
                                this.$message({
                                    type: "success",
                                    message: "删除成功"
                                });
                            }
                        });
                    }
                }
            });
        },
        delNode(treeData, data) {
            for (let i = 0; i < treeData.length; i++) {
                if (treeData[i].id === Number(data.id)) {
                    treeData.splice(i, 1);
                    break;
                }
                if (treeData[i].children && treeData[i].children.length > 0) {
                    this.delNode(treeData[i].children, data);
                }
            }
            return treeData;
        },
        liType(val) {
            this.type = val;
        }
    },
    
    components: {
        Head,
        Child
        // orgtree
    },
    watch: {
        activeName: function(newVal, oldVal) {
            console.log(oldVal,'----oldVal');
            console.log(newVal,'----newVal');
           /*  let that = this;
            if (this.chartsSrc == "") {
                // const loading = this.$loading({
                //     lock: true,
                //     // text: "组织结构世系图生成中，请稍后……",
                //     text: "超大图，加载需要时间，请耐心等待",
                //     spinner: "el-icon-loading",
                //     background: "rgba(0, 0, 0, 0.7)"
                // });
                api.familyGetchat(localStorage.getItem("fid")).then((res) => {
                    this.chartsSrc = "https://www.xsdjp.com" + res.data;
                    this.chartsSrcs[0]= "https://www.xsdjp.com" + res.data;
                    console.log( this.chartsSrcs,'--- this.chartsSrcs')
                    this.imgShow()
                    // var timer = setTimeout(function() {
                        // loading.close();
                    //     let viewer = viewerApi({
                    //         options: {
                    //             inline: true,
                    //             button: false,
                    //             navbar: false,
                    //             title: false,
                    //             toolbar: false,
                    //             tooltip: true,//是否显示缩放百分比
                    //             movable: true,//是否可以移动图片
                    //             zoomable: true,//是否可以缩放图像
                    //             zoomOnTouch:true,//是否开启触摸缩放图像功能
                    //             toggleOnDblclick:true,//是否在双击图像时在其自然大小和初始大小之间切换图像大小；双击图像时自动调用切换方法
                    //             rotatable: false,//是否允许旋转图片
                    //             scalable: false,//是否可以缩放图像
                    //             transition: false,
                    //             fullscreen: false,
                    //             keyboard: false,
                    //             backdrop: false,
                    //             maxZoomRatio:100,//最大缩放比例
                    //             viewed:function(){//回调函数，加载展示图片后调用
                    //                 console.log(111);
                    //                 let canvasH= document.getElementsByClassName("viewer-canvas")[0]
                    //                 canvasH.firstChild.style.marginTop='50px'
                    //                 canvasH.firstChild.style.marginLeft='20px'
                    //                 console.log(canvasH,'---canvasH');
                    //             },
                    //             zoomed:function(){
                    //                 let canvasH= document.getElementsByClassName("viewer-canvas")[0]
                    //                 //    console.log(canvasH,'---canvasH') 
                    //                 //    console.log(canvasH.firstChild,'---firstChild') 
                    //                 canvasH.firstChild.style.marginTop='50px'
                    //                 canvasH.firstChild.style.marginLeft='20px'
                    //                 // console.log(canvasH.firstElementChild,'---firstElementChild') 
                    //             },
                    //             moved:function(){
                    //                 let canvasH= document.getElementsByClassName("viewer-canvas")[0]
                    //             //    console.log(canvasH,'----canvasHmoved')
                    //                 // canvasH.firstChild.style.marginTop='50px'
                    //             }

                    //         },
                    //         images: [that.chartsSrc],
                    //     });
                      
                    //     viewer.options.zoomed=function(){
                    //         let canvasH= document.getElementsByClassName("viewer-canvas")[0]
                    //     //    console.log(canvasH,'---canvasH') 
                    //     //    console.log(canvasH.firstChild,'---firstChild') 
                    //        canvasH.firstChild.style.marginTop='50px'
                    //        canvasH.firstChild.style.marginLeft='0px'
                    //     // console.log(canvasH.firstElementChild,'---firstElementChild') 
                    //     }

                        
                    //     that.view = document.getElementsByClassName("viewer-container")[0];
                    //     let viewClose = document.getElementsByClassName("viewer-close")[0];
                    //     let viewnext = document.getElementsByClassName("viewer-next")[0];
                    //     let viewprev = document.getElementsByClassName("viewer-prev")[0];
                    //     let viewplay = document.getElementsByClassName("viewer-play")[0];
                    //     // that.view.style.height = "200px";
                    //     let topVal=that.$refs.chart.getBoundingClientRect().top+50
                    //     console.log("calc(100% - "+topVal+"px)",'----------------topVal+80')
                    //     console.log("calc(100% - "+topVal+"px)",'----------------topVal')
                    //     that.view.style.height = "calc(100% - "+topVal+"px)";
                    //     // console.log(that.$refs.chart.getBoundingClientRect().top,'----top')
                    //     // that.view.style.bottom = "0px";
                    //     that.view.style.top = topVal+'px';
                       
                    //     viewClose.style.display = "none";
                    //     viewnext.style.display = "none";
                    //     viewprev.style.display = "none";
                    //     viewplay.style.display = "none";
                    //     let canvasImg= document.getElementsByClassName("viewer-canvas")[0]
                    //     console.log(canvasImg.firstChild,'------firstChid view');
                    //     canvasImg.firstChild.style.marginTop='50px !important';
                    //     canvasImg.firstChild.style.marginLeft='0px  !important';
                    //     viewer.zoomTo(0.6);
                        
                    //     // that.paneImg='<div><p>qwrqwrq</p></div>'
                    //     // console.log(document.getElementsByClassName("viewer-container")[0],'-----ddddd')
                    //     // that.paneImg=  document.getElementsByClassName("viewer-container")[0].innerHTML
                    //     // this.$refs.paneChart.innerHTML ='<div>2324</div>'
                    //     // console.log(that.paneImg,'----paneImg')
                    
                    // }, 1500);
                });
            }else{
                this.imgShow()
            } */
            // const nodes = this.echartsInit._chartsViews[0]._data._graphicEls;
            // var timer = setTimeout(() => {
            //     document.getElementById("paneChart").scrollLeft = nodes[1].x - window.innerWidth / 2 + 350;
            //     this.echartsInit.resize();
            // }, 200);
        },
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
    computed: {
        ph(val) {
            return function(val) {
                let ph = "";
                for (let i = 0; i < this.$store.state.phData.length; i++) {
                    if (val == this.$store.state.phData[i].val) {
                        ph = this.$store.state.phData[i].key;
                    }
                }
                return ph;
            };
        },
        toChies(val) {
            return function(val) {
                return this.$utils.toChies(val);
            };
        }
    }
};
</script>
<style>
.gesture-hint {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  padding: 10px 20px;
  border-radius: 5px;
  color: white;
  font-size: 16px;
  text-align: center;
  z-index: 9999;  /* 确保提示图显示在最上层 */
}

.gesture-hint img {
  width: 100px;  /* 调整图片大小 */
  height: auto;
  margin-bottom: 10px;
}

.gesture-hint p {
  margin: 0;
  font-size: 14px;
  margin-top: 5px;
}
.msgAlertBox {
  width: 100%;
}
@media screen and (min-width: 768px) {
  .msgAlertBox {
    width: 80% !important;
  }
}
.viewer-backdrop {
    /* background-color: rgba(191, 143, 0,1) !important; */
    background-color: rgba(255, 229, 153,1) !important;
    /* background-color: rgba(252, 176, 8,1) !important; */
    /* background-color: rgba(251,254,193,1) !important; */
}

</style>
<style lang="less" scoped>
.lineageChart {
    height: 100%;

    .chartTop {
        height: 55px;
        line-height: 55px;

        h1 {
            width: 350px;
            font-size: 20px;
        }

        > div {
            font-size: 16px;
        }
    }

    .info {
        width: 350px;
        padding: 10px 20px;
        box-sizing: border-box;

        .avator {
            height: 120px;
            width: 88px;
            border: 1px dashed #d9d9d9;
            line-height: 120px;
            text-align: center;
            cursor: pointer;
            display: inline-block;
            img{
            width: 90%;
            height: 90%;
            vertical-align: middle;
        }
        }

        h2,
        p {
            width: 220px;
            text-align: center;
        }

        h2 {
            font-size: 18px;
        }

        p {
            margin-top: 10px;
        }

        // .btnDiv {
        //     height: 60%;
        //     line-height: 60px;
        //     display: flex;
        //     justify-content: space-evenly;
        // }

        .spjj {
            p {
                text-align: left;
            }
        }
    }

    .chartImg {
        // position: absolute;
        // left: 360px;
        color: #409eff;
        font-size: 14px;
    }

    .chart {
        overflow: auto;
        text-align: center;
        width: 100%;
        padding: 1rem;

        > div {
            overflow: hidden;
        }

        .org-tree-container {
            background-color: #f2eee4;
        }

        .el-tabs {
            height: 100%;

            /deep/.el-tabs__content {
                width: 100%;
                height: calc(100% - 55px);
            }

            /deep/.el-tab-pane {
                height: 100%;
                overflow: auto;
            }
            
        }
    }

    //去掉最上级的before  after 即是去电最上层的连接线
    /deep/ .el-tree > div {
        &::before {
            display: none;
        }

        &::after {
            display: none;
        }
    }
    /deep/.el-tree-node.is-expanded>.el-tree-node__children {
        // display: block;
        overflow: visible;
    }
}
.viewer-canvas img{
    margin-top:100px !important;
}

</style>



// WEBPACK FOOTER //
// src/views/mobile/lineageChart.vue